const DB_NAME = 'wallLabsImages'
const STORE = 'wallpapers'
const DB_VERSION = 1

function openDb() {
  return new Promise((resolve, reject) => {
    const request = indexedDB.open(DB_NAME, DB_VERSION)
    request.onupgradeneeded = () => {
      const db = request.result
      if (!db.objectStoreNames.contains(STORE)) {
        db.createObjectStore(STORE, { keyPath: 'id' })
      }
    }
    request.onsuccess = () => resolve(request.result)
    request.onerror = () => reject(request.error)
  })
}

export async function saveLocalWallpaperImage(id, file) {
  if (!id || !file) return

  const buffer = await file.arrayBuffer()
  const db = await openDb()

  return new Promise((resolve, reject) => {
    const tx = db.transaction(STORE, 'readwrite')
    tx.objectStore(STORE).put({
      id,
      buffer,
      mimeType: file.type || 'image/png',
      fileName: file.name || '',
      updatedAt: Date.now()
    })
    tx.oncomplete = () => resolve()
    tx.onerror = () => reject(tx.error)
  })
}

export function recordToObjectUrl(record) {
  if (!record?.buffer) return null
  const blob = new Blob([record.buffer], {
    type: record.mimeType || 'image/png'
  })
  return URL.createObjectURL(blob)
}

export async function getAllLocalWallpaperRecords() {
  const db = await openDb()
  return new Promise((resolve) => {
    const tx = db.transaction(STORE, 'readonly')
    const request = tx.objectStore(STORE).getAll()
    request.onsuccess = () => resolve(request.result || [])
    request.onerror = () => resolve([])
  })
}
